import { datadogRum } from "@datadog/browser-rum";

function datadogEnabled() {
  return process.env.REACT_APP_ENV !== "local";
}

export function initDatadogRum() {
  if (!datadogEnabled()) {
    return;
  }

  datadogRum.init({
    applicationId: "eb0242e8-9f6a-43eb-a9d6-60fbddb643af",
    clientToken: "pub5cc282a0928a7fa538e2296adb230cc8",
    site: "us5.datadoghq.com",
    service: "ebis-amt-ui",
    env: process.env.REACT_APP_ENV,
    version: process.env.REACT_APP_GIT,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
    silentMultipleInit: true
  });
  datadogRum.startSessionReplayRecording();
}

export function setDatadogUser(userData) {
  if (!datadogEnabled() || !userData) {
    return;
  }

  const id = userData.userId || userData.preferred_username;
  if (!id) {
    return;
  }

  datadogRum.setUser({
    id: id,
    email: userData.preferred_username || userData.email
  });
}

export function clearDatadogUser() {
  if (!datadogEnabled()) {
    return;
  }
  datadogRum.clearUser();
}

export function startDatadogView(url) {
  if (!datadogEnabled() || !url) {
    return;
  }
  datadogRum.startView(url);
}

export function reportDatadogError(error, context) {
  if (!datadogEnabled() || !error) {
    return;
  }
  datadogRum.addError(error, context);
}
